import get from 'lodash/get';
import { getUrlProperties } from './utils';

export const urlSelector = state => get(state, ['trovit', 'url']);
export const urlPropertiesSelector = state => getUrlProperties(urlSelector(state));

export const getVerticalIndexUrl = state => {
  const { protocol, hostname } = urlPropertiesSelector(state);
  const verticalPath = get(state, ['config', 'verticalPath'], '');

  return `${protocol}://${hostname}${verticalPath}`;
};

export const previousUrlSelector = state => get(state, ['trovit', 'previousUrl']);



// WEBPACK FOOTER //
// ./app/request/url/selectors.js